import {
    getBarInfo,
    getRecentRemoteNum,
    getServerOfflineBarNum,
    getAssistRemoteNum,
} from "@/requests/bar";

export default {
    namespaced: true,
    state: {
        barList: [],
        barId: "",
        barName: "",
        groupName: "",
        groupBarSum: "",
        groupBarOnline: "",
        recentRemoteNum: 0,
        assistRemoteNum: 0,
        serverOfflineBarNum: 0,
        searchBarNum: 0
    },
    // getters:{},
    mutations: {
        setBarInfo(state, barInfo) {
            state.barList = barInfo.barList;
            state.barId = barInfo.barId;
            state.barName = barInfo.barName;
            state.groupName = barInfo.groupName;
            state.groupBarSum = barInfo.groupBarSum;
            state.groupBarOnline = barInfo.groupBarOnline;
        },
        setBarAdminInfo(state, info) {
            state.recentRemoteNum = info.recentRemoteNum;
            state.assistRemoteNum = info.assistRemoteNum;
            state.serverOfflineBarNum = info.serverOfflineBarNum;
        }
    },
    actions: {
        // 更新网吧信息
        async actionUpdateBarInfo({ commit }, barId) {
            let res = await getBarInfo({
                barId
            });
            commit("setBarInfo", res);
        },
        // 更新网吧管理信息
        async actionUpdateBarAdminInfo({ commit }) {
            // 获取最近远程数
            let recentRemoteNum = await getRecentRemoteNum();
            // 获取远程协助数
            let assistRemoteNum = await getAssistRemoteNum();
            // 获取服务器离线的网吧数
            let serverOfflineBarNum = await getServerOfflineBarNum();
            commit("setBarAdminInfo", {
                recentRemoteNum,
                assistRemoteNum,
                serverOfflineBarNum
            });
        }
    }
};
